module.exports = __webpack_public_path__ + "c48fd112ba248cfce84276deff08906a.svg";